/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: LinkDataOrigin.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/6 @ 1749
 * ---
 * Description:
 */

import { observer }                   from 'mobx-react';
import {
  Editor
}                                     from '../../../../store/observables/Editor';
import classNames                     from 'classnames';
import { currentThemeIsDark }         from '../../../../common/utils';
import { Classes, Dialog, Tab, Tabs } from '@blueprintjs/core';
import React                          from 'react';
import { LinkMyLabel }                from '../../../dataorigins/LinkMyLabel';

interface Props {
  editor: Editor;
  isOpen: boolean;
  onClose: () => void;
}

enum DataOriginTabs {
  MYLABEL = 'MyLabel',
  FILE = 'Excel'
}

export const LinkDataOriginDialog = observer((props: Props) => {
  return (
    <Dialog
      usePortal
      className={ classNames({ 'bp4-dark': currentThemeIsDark() }) }
      style={ { width: '35rem', height: '30rem' } }
      isOpen={ props.isOpen }
      title="Nuova origine dati"
      onClose={ props.onClose }
      canOutsideClickClose={ false }
    >
      <div className={ Classes.DIALOG_BODY }>
        <div className="text-xl">Collega nuova origine dati</div>
        <div className="text-bpgray-200 my-2">
          Collega una nuova origine dati per aggiungere valori dinamici nella
          tua etichetta.
        </div>
        <div className="h-3/4">
          <Tabs id="originTabs" onChange={ () => {} }
                selectedTabId={ DataOriginTabs.MYLABEL }>
            <Tab id={ DataOriginTabs.MYLABEL } title="Accedi a MyLabel"
                 panel={ <LinkMyLabel editor={ props.editor }
                                      onLinkSuccessful={ () => {
                                        props.onClose();
                                      } }/> }/>
            <Tab id={ DataOriginTabs.FILE } title="Carica file" disabled/>
          </Tabs>
        </div>
        <div className="flex flex-row justify-end">

        </div>
      </div>
    </Dialog>
  );
});